import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { PlanCard } from "../../components/planCard/PlanCard";
import { GetHook } from "../../api/api";
import { TASKS_URL } from "../../api/urls";
import { get } from "../../utils/get";
import { ReloadPlanSubject } from "../../subjects/ReloadPlanSubject";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { AuthContext } from "../../context/AuthContext";
const color = ["#01A8CE", "#A28CFF", "#FCB444", "#13C997"];
const backgroundColor = ["#EAEFFF", "#E9E6FF", "#FFF2DF", "#D0F5EB"];

interface IProps {
  initiativeFilter?: string;
  objectiveFilter?: string;
  dateFilter?: string;
}
export const Tasks = ({
  initiativeFilter,
  objectiveFilter,
  dateFilter,
}: IProps) => {
  const location = useLocation();
  const idToReload = get(location, "key");
  const date =
    get(dateFilter, "startDate") && get(dateFilter, "endDate")
      ? `interval=${moment(get(dateFilter, "startDate")).format(
          "YYYY-MM-DD"
        )}/${moment(get(dateFilter, "endDate")).format("YYYY-MM-DD")}`
      : "";

  const auth = useContext(AuthContext);

  const { user } = get(auth, "authState");
  const { data: tasks, reload } = GetHook(
    initiativeFilter && objectiveFilter
      ? `${TASKS_URL}?owners=${get(
          user,
          "id"
        )}&initiative_id=${initiativeFilter}&objective_id=${objectiveFilter}&${date}`
      : initiativeFilter
      ? `${TASKS_URL}?owners=${get(
          user,
          "id"
        )}&initiative_id=${initiativeFilter}&${date}`
      : objectiveFilter
      ? `${TASKS_URL}?owners=${get(
          user,
          "id"
        )}&objective_id=${objectiveFilter}&${date}`
      : date
      ? `${TASKS_URL}?owners=${get(user, "id")}&${date}`
      : "null"
  );

  useEffect(() => {
    const planSub = ReloadPlanSubject.subscribe((payload) => {
      if (payload) {
        reload(idToReload);
        ReloadPlanSubject.next(false);
      }
    });
    return () => {
      planSub.unsubscribe();
    };
  }, [idToReload, reload]);
  const initiativeIds = [
    ...new Set(tasks.map((task) => get(task, "initiative_id"))),
  ];
  const taskData = initiativeIds.map((initiativeId, index) => {
    const allTasks = [
      ...new Set(
        tasks
          .map((task, i) => {
            if (initiativeId === get(task, "initiative_id")) {
              return task;
            }
          })
          .filter((n) => n !== undefined)
      ),
    ];
    return {
      headerText: get(allTasks, `[0]initiative.name`),
      color: color[index],
      backgroundColor: backgroundColor[index],
      allTasks,
    };
  });
  return (
    <PlanBody>
      <PlanCard cardData={taskData} />
    </PlanBody>
  );
};

const PlanBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 3em;
  padding: 0 2rem;
`;
